module.exports = __webpack_public_path__ + "img/huzhou.0dcbf30a.jpg";